export * from './managers/checkboxManager';
export * from './managers/carouselManager';
export * from './managers/dialogManager';
export * from './managers/sliderManager';

export { createManager } from './createManager';
export * from './types';
